var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal-overlay",
    { attrs: { "instance-class": "consent-management", id: _vm.id } },
    [
      _c("div", { staticClass: "modal-overlay__content__item" }, [
        _c("h1", { staticClass: "heading1 custom-color-f" }, [
          _vm._v("\n            Wir benötigen Ihre Zustimmung\n        "),
        ]),
        _vm._v(
          "\n        Wenn Sie zustimmen, binden wir Dienste und Cookies zur Analyse, Beratung und Kartendarstellung ein.\n        "
        ),
        _c("ul", [
          _c("li", [
            _c("b", [_vm._v("Nutzungsanalyse")]),
            _vm._v(
              " misst das Besuchsverhalten per Cookie. Ihre IP-Adresse wird umgehend gelöscht, eine Datennutzung durch Google zu eigenen Zwecken ist untersagt.\n          "
            ),
          ]),
          _vm._v(" "),
          _vm.showFdaConsent
            ? _c("li", [
                _c("b", [_vm._v("LiveChat „Frag die Apotheke“")]),
                _vm._v(
                  " ermöglicht Kontakt mit Experten von „Frag die Apotheke“.\n          "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("li", [
            _c("b", [_vm._v("HERE Maps")]),
            _vm._v(" zeigt interaktive Karten.\n          "),
          ]),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n        Sie können Ihre Auswahl jederzeit detailliert anpassen. Weitere Informationen und die Möglichkeit zum Widerruf finden Sie in unserer "
          ),
          _c(
            "a",
            {
              staticClass: "custom-color-b",
              attrs: {
                href: "/Datenschutz",
                target: "_blank",
                rel: "noopener noreferrer nofollow",
              },
            },
            [_vm._v("Datenschutzerklärung")]
          ),
          _vm._v(
            ". Bei der Nutzung von Chat und Karten werden technische Daten (insb. Ihre IP-Adresse) an die Anbieter übermittelt und Cookies gesetzt. Hierfür gelten die Datenschutzhinweise der jeweiligen Anbieter.\n        "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "consent-line" }, [
          _vm._v("\n            Websiteanalyse\n            "),
          _c("label", { staticClass: "toggle-switch" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.gaConsent,
                  expression: "gaConsent",
                },
              ],
              attrs: { type: "checkbox" },
              domProps: {
                checked: Array.isArray(_vm.gaConsent)
                  ? _vm._i(_vm.gaConsent, null) > -1
                  : _vm.gaConsent,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.gaConsent,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.gaConsent = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.gaConsent = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.gaConsent = $$c
                  }
                },
              },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "slider" }),
          ]),
        ]),
        _vm._v(" "),
        _vm.showFdaConsent
          ? _c("div", { staticClass: "consent-line" }, [
              _vm._v(
                "\n            Externe Inhalte („Frag die Apotheke“)\n            "
              ),
              _c("label", { staticClass: "toggle-switch" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.fdaConsent,
                      expression: "fdaConsent",
                    },
                  ],
                  attrs: { type: "checkbox" },
                  domProps: {
                    checked: Array.isArray(_vm.fdaConsent)
                      ? _vm._i(_vm.fdaConsent, null) > -1
                      : _vm.fdaConsent,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.fdaConsent,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.fdaConsent = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.fdaConsent = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.fdaConsent = $$c
                      }
                    },
                  },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "slider" }),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "consent-line" }, [
          _vm._v("\n            Karten (HERE Maps)\n            "),
          _c("label", { staticClass: "toggle-switch" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.mapConsent,
                  expression: "mapConsent",
                },
              ],
              attrs: { type: "checkbox" },
              domProps: {
                checked: Array.isArray(_vm.mapConsent)
                  ? _vm._i(_vm.mapConsent, null) > -1
                  : _vm.mapConsent,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.mapConsent,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.mapConsent = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.mapConsent = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.mapConsent = $$c
                  }
                },
              },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "slider" }),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "button-container" }, [
          _c(
            "button",
            {
              staticClass:
                "button button--invert custom-color-b custom-border-color-b",
              on: { click: _vm.dissent },
            },
            [_vm._v("\n                Ablehnen\n            ")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass:
                "button button--invert custom-color-b custom-border-color-b",
              on: { click: _vm.save },
            },
            [_vm._v("\n                Auswahl speichern\n            ")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass:
                "button button--invert custom-color-b custom-border-color-b",
              on: { click: _vm.consent },
            },
            [_vm._v("\n                Zustimmen\n            ")]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "consent-imprint custom-border-color-b" }, [
          _c(
            "a",
            {
              staticClass: "custom-color-b",
              attrs: {
                href: "/Impressum",
                target: "_blank",
                rel: "noopener noreferrer nofollow",
              },
            },
            [_vm._v("Impressum")]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }